/**
 * Centralized z-index scale for the design system.
 *
 * Each value is a **complete, literal Tailwind class string** (e.g. `"z-[1020]"`). Keeping the
 * full class as a static literal is what lets Tailwind's scanner pick it up — the class name is
 * emitted because it appears verbatim in this scanned source file. Never build these at runtime
 * (`` `z-[${n}]` ``): an interpolated string is invisible to the scanner and produces no CSS.
 *
 * Seeded from @tellescope/ui's layering; subject to review/consolidation as components migrate in.
 */
export const Z_INDEX = {
  base: "z-[1]",
  raised: "z-[10]",
  sidebar: "z-[30]",
  header: "z-[35]",
  tableHeader: "z-[40]",
  dropdown: "z-[1000]",
  overlay: "z-[2000]",
  sheet: "z-[2020]",
  modalOverlay: "z-[2030]",
  modal: "z-[2040]",
  alertDialog: "z-[2060]",
  floatingWindow: "z-[2500]",
  popover: "z-[2600]",
  tooltip: "z-[2700]",
  toast: "z-[3000]",
} as const;

export type ZIndexLayer = keyof typeof Z_INDEX;
